import {
    isValidElement,
    type ReactNode,
    Children,
    useMemo,
    type FC
} from "react";
import {
    Animated
} from "react-native";
import type ITableBodyProps from "./type";
import {
    TableSectionContext,
    useTableContext
} from "../../context";
import type {
    TableSectionContextType
} from "../../type";
import {
    PRESENCE_LIST_CHANGE_LIMIT
} from "../../../presenceList/util";
import PresenceList from "../../../presenceList";

const TableBodyRow: FC<{
    children?: ReactNode;
    isLast: boolean;
}> = ({
    children,
    isLast
}) => {
    const value = useMemo<TableSectionContextType>(() => ({
        section: "body",
        isLast
    }), [
        isLast
    ]);

    return <TableSectionContext.Provider
        value={value}
    >
        {children}
    </TableSectionContext.Provider>;
};

const TableBody: FC<ITableBodyProps> = ({
    children,
    style,
    ...props
}) => {
    const context = useTableContext({
        part: "Body"
    });

    if(!context) {
        return null;
    }

    const rows = Children.toArray(children);

    return <Animated.View
        {...props}
        role="rowgroup"
        style={style}
    >
        <PresenceList
            animatedChangeLimit={PRESENCE_LIST_CHANGE_LIMIT}
            customTheme={context.customTheme}
            gap={0}
        >
            {
                rows.map((row, index) => <TableBodyRow
                    key={isValidElement(row) && row.key !== null ? row.key : index}
                    isLast={index === rows.length - 1}
                >
                    {row}
                </TableBodyRow>)
            }
        </PresenceList>
    </Animated.View>;
};
export default TableBody;
